import { t } from "i18next";
import type React from "react";

import { useFullReleaseStrict } from "@/common/hooks_useFullRelease";
import Typography from "@mui/material/Typography";
import Toolbar from "@imminently/decisively-ui/Toolbar";

import type { AliasExpression } from "@packages/compiler";
export const AliasInfo = ({
  expression,
  ...props
}: { expression: AliasExpression } & React.HTMLAttributes<HTMLDivElement>) => {
  const { alias } = expression;
  const release = useFullReleaseStrict();
  const relationship = release.relationships.find((r) => r.id === alias.relationshipId);

  if (!relationship) {
    return (
      <div className="flex flex-col p-4">
        <Typography>Relationship alias (pending document save)</Typography>
      </div>
    );
  }

  const target =
    relationship.textSingular ??
    release.relationships.find((r) => r.target === relationship.target)?.textSingular ??
    "ERROR MISSING";

  return (
    <div
      className="flex flex-col px-4 py-2"
      {...props}
    >
      <div className="flex items-center gap-1">
        <Typography>{t("alias")}</Typography>
        <Toolbar.Divider />
        <Typography style={{ fontWeight: 500 }}>{target}</Typography>
      </div>
    </div>
  );
};
